<script>
export default {
  name: 'CreateSubscription',
  data() {
    return {
      planId: process.env.VUE_APP_PAYPAL_PLAN_ID,
      style: {
        color: 'gold'
      }
    }
  },
  mounted() {
    const { createSubscription, onApprove, style } = this
    paypal
      .Buttons({
        createSubscription,
        onApprove,
        style
      })
      .render('#paypal-button-container')
  },
  methods: {
    async subscribe(payload) {
      this.$emit('subscribe', payload)
    },
    createSubscription(data, actions) {
      return actions.subscription.create({
        plan_id: this.planId
      })
    },
    onApprove(data, actions) {
      this.subscribe(data)
    }
  }
}
</script>

<template>
  <div id="paypal-button-container" />
</template>
